import React from 'react';
import { Container } from './Container';
import { SectionHeading } from './SectionHeading';
import { benefits } from '../data/content';
const dots = ['bg-clay', 'bg-sage', 'bg-sky', 'bg-sun', 'bg-clay', 'bg-sage'];
export function FuturePaced() {
  return <section aria-labelledby="future-heading" className="bg-paper py-16 sm:py-24" data-id="element-76" data-mp="14wg41sosvwz5">
      <Container narrow data-id="element-77" data-mp="10si4jgvkck5k">
        <SectionHeading id="future-heading" eyebrow="Your after-state" title="Imagine What Your Afternoons Will Look Like…" data-id="element-78" data-mp="10v4eto9u9drh" />

        <ul className="mt-11 grid grid-cols-1 gap-4 sm:mt-14 lg:grid-cols-2" data-id="element-79" data-mp="r1drwntd1bdw">
          {benefits.map((benefit, index) => <li key={benefit} className="flex gap-4 rounded-card border border-hairline bg-white p-5 shadow-paper sm:p-6" data-id="element-80" data-mp="m1iyodm449po" data-mpi={index}>
              <span aria-hidden="true" className={`mt-2 h-2.5 w-2.5 flex-none rounded-full ${dots[index % dots.length]}`} data-id="element-81" data-mp="d1vzlyguvfzs" />
              <p className="text-[17px] leading-[1.62] text-inkSoft sm:text-[18px]" data-id="element-82" data-mp="35i2c0sss6waf">{benefit}</p>
            </li>)}
        </ul>

        <blockquote className="relative mt-12 overflow-hidden rounded-xl2 bg-ink px-6 py-12 text-center sm:mt-16 sm:px-14 sm:py-16" data-id="element-83" data-mp="3aavgdfkc82lz">
          <p className="mx-auto max-w-[660px] font-display text-[23px] font-semibold leading-[1.35] tracking-[-0.015em] text-white sm:text-[31px]" data-id="element-84" data-mp="30jh7ih6hxqg6">
            Because in the world they’re growing into, consuming information won’t be enough.
            <span className="mt-5 block text-sun" data-id="element-85" data-mp="3t73mell6chic">
              The advantage will belong to those who can imagine, create and turn an idea into
              something real.
            </span>
          </p>
        </blockquote>
      </Container>
    </section>;
}